export const CAR_REPORT_STATUS_MAP: Record<string, string> = {
    NEW: 'New',
    DRAFT: 'Draft',
    IN_PROGRESS: 'In progress',
    CLOSED: 'Closed',
    CLOSED_WITHOUT_ACTION: 'Closed w/o action',
    RE_OPEN: 'Re-open',
};

const normalizeStatusKey = (raw?: string) =>
    String(raw ?? '')
        .trim()
        .toUpperCase()
        .replace(/[\s-]+/g, '_');

export const toDisplayStatus = (raw?: string): string => {
    const key = normalizeStatusKey(raw);
    if (!key) return 'New';
    return CAR_REPORT_STATUS_MAP[key] ?? 'New';
};
